import Divider from '@mui/material/Divider'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import React from 'react'

import { convertDateTimeToPreferedTimezone } from 'data/dateTime/convertDateTimeToPreferedTimezone'
import T from 'T'
import { EXCEPTION_AUDIT_ACTION, getExceptionAuditTrail } from 'utils/exceptionAudit'

import type { ExceptionAuditAction } from 'utils/exceptionAudit'

// Revision history at the drawer bottom (latest first), from the exception's Envers
// revisions. Hidden while there is no audit data (create flow, or BE not deployed yet).
type ExceptionAuditTrailProps = {
  revisions?: unknown[]
}

const ACTION_HEADER: Record<ExceptionAuditAction, string> = {
  [EXCEPTION_AUDIT_ACTION.CREATED]: T.CREATED_BY_HEADER,
  [EXCEPTION_AUDIT_ACTION.UPDATED]: T.UPDATED_BY_HEADER,
  [EXCEPTION_AUDIT_ACTION.DELETED]: T.DELETED_BY_HEADER,
}

const formatEntryDate = (at: string): string => {
  if (!at) return ''
  const { onlyDate, onlyTime } = convertDateTimeToPreferedTimezone({ dateTime: at })
  return [onlyDate, onlyTime].filter(Boolean).join(' ')
}

const ExceptionAuditTrail: React.FC<ExceptionAuditTrailProps> = ({ revisions }) => {
  const entries = getExceptionAuditTrail(revisions)

  if (entries.length === 0) return null

  return (
    <Stack gap={1} mt={3}>
      <Divider />
      <Typography fontWeight={600} variant="subtitle2">
        {T.ACTIVITY_HISTORY}
      </Typography>
      {entries.map(entry => (
        <Stack key={entry.key} alignItems="center" direction="row" gap={1} justifyContent="space-between">
          <Typography variant="body2">{`${ACTION_HEADER[entry.action]} ${entry.userName}`}</Typography>
          <Typography color="text.secondary" sx={{ whiteSpace: 'nowrap' }} variant="caption">
            {formatEntryDate(entry.at)}
          </Typography>
        </Stack>
      ))}
    </Stack>
  )
}

export default ExceptionAuditTrail
